import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { StockApiResponse, StockUsageState } from './types';

export const STOCK_USAGE_QUERY_KEY = ['stock-usage'] as const;

/**
 * Stan dziennej puli pobrań. Liczony po naszej stronie, bo Magnific nie
 * wystawia stanu limitu: Analytics API pokazuje wyłącznie historię i jest
 * dostępne dopiero od planu Business.
 */
export const useGetStockUsage = (): UseQueryResult<StockUsageState, AxiosError> => useQuery<
  StockUsageState,
  AxiosError
>({
  queryKey: STOCK_USAGE_QUERY_KEY,
  queryFn: async () => {
    const res = await axiosInstance.get<StockApiResponse<StockUsageState>>('/v3-getStockUsage');
    return res.data.data;
  },
  staleTime: 60_000,
  refetchOnWindowFocus: false,
});
